export const LIMIT_CANVAS_WIDTH_CLASS_NAME = 'limit-canvas-width'
